import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleNavigate } from 'page/Application/ManageProductAndService/utils/navigate/navigateNotifyTopPage';
import AntdTable from 'components/AntdTable';
import LinkNotify from 'page/Application/ManageProductAndService/TopPageProductPartnerUser/component/LinkNotify';
import dayjs from 'dayjs';
import { DATE_FORMAT_LIST } from 'constant/notificationConstants';
import { ButtonAction } from 'style/styleComponent/styled';
import { Pinned } from '../../styled';
import { useRecoilValue } from 'recoil';
import { network } from 'recoil/atom/network';

const NewestTable = ({
  dataSource,
  setDataSource,
  isLoading,
  emptyText,
  isDisabledPin,
  refetch,
  setNotifyId,
  productId,
  errorNetWork,
}) => {
  const navigate = useNavigate();
  const isOnline = useRecoilValue(network);
  const columns = useMemo(() => {
    const handlePin = (notifyId) => {
      setDataSource((prevState) => {
        let lstNewSource = prevState.map((data, index) => {
          if (data.isPinned == true) {
            if (data.notifyOrderId == 1) {
              data.notifyOrderId = 2;
            } else if (data.notifyOrderId == 2) {
              data.isPinned = false;
            }
          }
          if (data.notifyId === notifyId) {
            data.isPinned = true;
            data.notifyOrderId = 1;
          }
          return data;
        });
        return lstNewSource;
      });
    };
    return [
      {
        title: 'space',
        key: 'space',
        width: 50,
        responsive: ['sm'],
      },
      {
        title: 'お知らせ',
        render: (record) => (
          <>
            <div>
              {record?.destinationType === 'NO_DETAILS' ? (
                <p style={{ wordBreak: 'break-word' }}>
                  {record.titleWithCategory}
                </p>
              ) : (
                <LinkNotify
                  text={record.titleWithCategory}
                  type={record?.destinationType}
                  handleNavigate={() =>
                    handleNavigate(
                      record,
                      navigate,
                      setNotifyId,
                      refetch,
                      productId,
                    )
                  }
                />
              )}
            </div>
            <p>{dayjs(record.displayDate).format(DATE_FORMAT_LIST[1])}</p>
          </>
        ),
        responsive: ['xs'],
      },
      {
        key: 'displayedDate',
        dataIndex: 'displayedDate',
        align: 'left',
        ellipsis: true,
        width: '150px',
        responsive: ['sm'],
        render: (text) => {
          return (
            <div title={''}>{dayjs(text).format(DATE_FORMAT_LIST[1])}</div>
          );
        },
        showSorterTooltip: false,
        sorter: true,
      },
      {
        key: 'titleWithCategory',
        title: 'お知らせ',
        dataIndex: 'titleWithCategory',
        align: 'left',
        showSorterTooltip: false,
        sorter: true,
        responsive: ['sm'],
        render: (text, record) => {
          return record?.destinationType === 'NO_DETAILS' ? (
            <span>{text}</span>
          ) : (
            <LinkNotify
              text={text}
              type={record?.destinationType}
              handleNavigate={() => {
                if (isOnline) {
                  handleNavigate(
                    record,
                    navigate,
                    setNotifyId,
                    refetch,
                    productId,
                  ).then();
                } else {
                  errorNetWork();
                }
              }}
            />
          );
        },
      },
      {
        key: 'notifyId',
        dataIndex: 'notifyId',
        render: (notifyId) => (
          <ButtonAction
            type="link"
            onClick={() => handlePin(notifyId)}
            disabled={isDisabledPin}
            icon={<Pinned />}
          />
        ),
        align: 'center',
        width: 50,
      },
    ];
  }, [
    setDataSource,
    navigate,
    setNotifyId,
    refetch,
    productId,
    isDisabledPin,
    isOnline,
  ]);

  const dataSourceNewest = useMemo(() => {
    if (dataSource && dataSource != [] && dataSource != undefined) {
      let count = 0;
      return dataSource
        .sort((o1, o2) =>
          o1.displayedDate < o2.displayedDate
            ? 1
            : o1.displayedDate > o2.displayedDate
              ? -1
              : 0,
        )
        .filter((item) => {
          if (!item.isPinned) {
            count++;
          }
          if (count < 6) {
            return !item.isPinned;
          }
        });
    }
  }, [dataSource]);

  return (
    <>
      {!isLoading && dataSourceNewest != [] && (
        <AntdTable
          columns={columns}
          isLoading={isLoading}
          dataSource={dataSourceNewest}
          emptyText={emptyText}
          showHeader={false}
          isBoldBottomBorder={true}
        />
      )}
    </>
  );
};

export default NewestTable;
